module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/izumiya-2a60e5024721bf4bbf02833b47081c33.jpg";